import { useEffect, useState } from 'react';
import { useCurrentUserStore } from 'store/UserStore';
import { Permission } from 'interfaces';
import { useIsAdmin } from 'hooks/useIsAdmin';

interface CanUploadReturn {
  canUpload: boolean;
}

export const useCanUpload = (path: string): CanUploadReturn => {
  const { role } = useCurrentUserStore();
  const isAdmin = useIsAdmin();
  const [canUpload, setCanUpload] = useState<boolean>(false);

  useEffect(() => {
    if (isAdmin) {
      setCanUpload(true);
    } else {
      const hasUploadPermission =
        role?.permissions?.some(
          (permission: Permission) =>
            permission.resource === path && permission.action === 'upload'
        ) ?? false;
      setCanUpload(hasUploadPermission);
    }
  }, [isAdmin, path, role]);

  return { canUpload };
};
